import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useIsUserLoggedIn } from '../../../global-utils';
import { setIsAdminClientPreview } from '../actions';

const useIsAdminClientPreview = () => {
  // https://jmarquardt.atlassian.net/browse/MEV-3162
  const isLoggedIn = useIsUserLoggedIn();
  const location = useLocation();
  const dispatch = useDispatch();

  const hasPreviewParams = useMemo(() => {
    const urlParams = new URLSearchParams(location.search);
    const isPreview = urlParams.get('preview') === 'true';
    // MEV-9002 remove the jwt_token param check since it getting remove and we do check isLoggedIn && hasPreviewParams

    return isPreview;
  }, [location.search]);

  const isAdminClientPreview = isLoggedIn && hasPreviewParams;

  useEffect(() => {
    dispatch(setIsAdminClientPreview(isAdminClientPreview));
  }, [dispatch, isAdminClientPreview]);
};

export default useIsAdminClientPreview;
